"use strict";

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var rich_text_types_1 = require("@contentful/rich-text-types");

exports.emptyDocument = {
  content: [],
  data: {},
  nodeType: rich_text_types_1.BLOCKS.DOCUMENT
};
/**
 * ViewportContext provides context containing the current viewport ("none", "xs", ...) as used by LSG Components
 */

exports.ViewportContext = react_1["default"].createContext('none');
/**
 * React Hook to make use of the current viewport size
 */

exports.useViewportSize = function () {
  return react_1.useContext(exports.ViewportContext);
};

function clampNumber(value, lowerBoundary, higherBoundary) {
  return Math.min(Math.max(value, lowerBoundary), higherBoundary);
}

exports.clampNumber = clampNumber;

function calculateRelativeImageFocalPointFrom(focalPoint, imageWidth, imageHeight) {
  var _a, _b, _c, _d;

  if (typeof imageWidth === 'undefined' || typeof imageHeight === 'undefined') {
    return {
      offsetLeft: 0,
      offsetTop: 0
    };
  }

  var clampedX = clampNumber((_b = (_a = focalPoint) === null || _a === void 0 ? void 0 : _a.x, _b !== null && _b !== void 0 ? _b : 0), 0, imageWidth);
  var clampedY = clampNumber((_d = (_c = focalPoint) === null || _c === void 0 ? void 0 : _c.y, _d !== null && _d !== void 0 ? _d : 0), 0, imageHeight);
  return {
    offsetLeft: clampedX / imageWidth * 100,
    offsetTop: clampedY / imageHeight * 100
  };
}

exports.calculateRelativeImageFocalPointFrom = calculateRelativeImageFocalPointFrom;